import { defaultHttpClient } from '../../httpClient';
import type { GoodsReviewsPhotoFeedsResponse } from './types';

/**
 * - 상품 포토 리뷰 피드 조회 API
 */
export const getGoodsReviewsPhotoFeeds = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsReviewsPhotoFeedsResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/photo-feeds/`,
    })
    .then(result => result.data);
};